module.exports = __webpack_public_path__ + "img/icon-zhirong.a6c72810.png";